import { useState } from "react";

function useStations(mapStations) {
  const newMapStations = new Map(mapStations);

  const [stations, setStations] = useState([]);

  const updateStations = (companiesSelected) => {
    const stationsSelected = [];
    companiesSelected.forEach((item) => {
      const actualStation = newMapStations.get(item.value);

      if (actualStation) {
        stationsSelected.push(...actualStation.stations);
      }
    });

    const newStations = stationsSelected.map((station) => {
      return { value: station.id, label: station.name };
    });
    setStations(newStations);
  };
  const updateOneStation = (companiyID) => {
    const actualStation = newMapStations.get(companiyID);

    const newStations = actualStation
      ? actualStation.stations.map((station) => {
          return { id: station.id, name: station.name };
        })
      : [];

    setStations(newStations);
  };

  return { stations, updateStations, updateOneStation };
}

export { useStations };
